import "./../css/style.scss";
import $ from 'jquery';

// Cookies
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

$(document).ready(function () {
    let didScroll;
    let lastScrollTop = 0;
    const delta = 5;
    const header = $('#header');
    const navbarHeight = header.outerHeight();
    // on scroll, let the interval function know the user has scrolled
    $(window).scroll(function () {
        didScroll = true;
    });
    // run hasScrolled() and reset didScroll status
    setInterval(function () {
        if (didScroll) {
            hasScrolledMain();
            didScroll = false;
        }
    }, 250);

    function hasScrolledMain() {
        const st = $(window).scrollTop();
        // When not on top extra class for header
        if (st > navbarHeight) {
            header.removeClass('menu-top').addClass('menu-down');
        } else {
            header.removeClass('menu-down').addClass('menu-top');
        }
        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta) {
            return;
        }

        // If current position > last position AND scrolled past navbar...
        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            header.removeClass('scroll-down-nav').addClass('scroll-up-nav');
            //$('#responsive-menu-button').removeClass('scroll-down-nav').addClass('scroll-up-nav');
        } else {
            // Scroll Up
            // If did not scroll past the document (possible on mac)...
            if (st + $(window).height() < $(document).height()) {
                header.removeClass('scroll-up-nav').addClass('scroll-down-nav');
                //$('#responsive-menu-button').removeClass('scroll-up-nav').addClass('scroll-down-nav');
            }
        }
        lastScrollTop = st;
    }

    // Move first section on page bellow header
    $('#container').css("padding-top", navbarHeight);

    // Close top header
    $('.header-notice__close').on('click', function () {
        $(this).closest('.header-top').hide();

        // Move first section on page bellow header
        $('#container').css("padding-top", $('#header').outerHeight());

        // Set cookie for 48 hours
        setCookie('noticeBar', false, 2);
    });

    // Footer accordion on mobile, blog posts slider on mobile on home page
    if ($(window).width() < 600) {
        $('.mobile-accordion-menu .menu-item-has-children > a').on('click', function (event) {
            event.preventDefault();

            $('.mobile-accordion-menu .menu-item-has-children .sub-menu').each(function () {
                $(this).slideUp();
                $(this).parent().removeClass('open');
            });
            if ($(this).next().is(':visible')) {
                $(this).next().slideUp();
                $(this).parent().removeClass('open');
            } else {
                $(this).next().slideDown();
                $(this).parent().addClass('open');
            }
        });

        $('.mobile-slider-posts').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            dotsClass: 'slick-dots list-no-bullets'
        });
    }

    // Location accordion
    $('.location-accordion .locations__single .locations__closed-part').on('click', function () {
        $('.location-accordion .locations__single .locations__open-part').each(function () {
            $(this).slideUp();
            $(this).parent().removeClass('open');
        });
        if ($(this).next().is(':visible')) {
            $(this).next().slideUp();
            $(this).parent().removeClass('open');
        } else {
            $(this).next().slideDown();
            $(this).parent().addClass('open');
        }
    });

    var appendTo = $('.single-blog .single-blog__main .single-blog__main__sidebar .single-blog__main__sidebar__contents');
    $('.single-blog__main__wrap__content h2').each(function () {
        var h2Text = $(this).text();
        var h2Anchor = $(this).attr('id');

        if (h2Anchor) {
            var tableOfcontents = "<p anchor='" + h2Anchor + "'>" + h2Text + "</p>";
        }

        appendTo.append(tableOfcontents);
    });
    var firstContent = $('.single-blog .single-blog__main .single-blog__main__sidebar .single-blog__main__sidebar__contents p:first-child');
    firstContent.addClass('active');

    $('.single-blog__main__sidebar__contents p').on("click", function () {
        var h2AnchorClicked = $(this).attr('anchor');
        $('.single-blog__main__sidebar__contents p').removeClass('active');
        $(this).addClass('active');

        var scrollTo = document.getElementById(h2AnchorClicked);

        scrollTo.scrollIntoView({behavior: "smooth"});

    });

    if ($('.single-blog .single-blog__main .single-blog__main__sidebar').length) {
        var fixedElement = $('.single-blog .single-blog__main .single-blog__main__sidebar');
        var fixedHeight = fixedElement.innerHeight();
        var aboveSticky = $('.single-blog .single-blog__header');
        var stopper = $('#to-cross-element');
        var headerHeight = $('#header').innerHeight();

        if (fixedElement.offset()) {

            var fixedTop = fixedElement.offset().top;
            var stickOffset = aboveSticky.innerHeight();

            var stopperPosition = stopper.offset().top;
            var stopPoint = stopperPosition - fixedHeight - stickOffset;
            var diff = stopPoint + stickOffset - headerHeight - fixedHeight;

            $(window).scroll(function () {
                var windowTop = $(window).scrollTop();

                var stickyTopOnChange = fixedElement.offset().top;

                if (stopPoint < windowTop) {
                    fixedElement.css({position: 'absolute', top: diff});
                } else if (fixedTop < windowTop + stickOffset) {
                    fixedElement.css({position: 'fixed', top: stickOffset});
                } else if (fixedTop >= stickyTopOnChange) {
                    fixedElement.css({position: 'absolute', top: 'initial'});
                } else {
                    fixedElement.css({position: 'absolute', top: 'initial'});
                }
            });

        }
    }

    /*global ajaxurl*/

    /*eslint no-undef: "error"*/
    function AjaxPosts(category, numberdisplayedvalue) {
        $(".archive-blog .archive-blog__ajax").addClass("loading");
        $.ajax({
            type: "post",
            url: ajaxurl,
            data: {
                action: "archive_posts",
                ownumberdisplayed: numberdisplayedvalue,
                id: category,
            },
            beforeSend: function () {
                var tempHtml = $(".archive-blog__ajax__hidden").html();
                $(".archive-blog .archive-blog__ajax .archive-blog__ajax__visible__list").append(tempHtml);
                if (parseInt($("#archive-blog__ajax").attr("data-numberdisplayed")) >= parseInt($("#archive-blog__ajax").data("total"))) {
                    $(".archive .archive-blog .button-dinos").hide();
                }
                if (numberdisplayedvalue != 0) {
                    $('.archive .archive-blog .button-dinos').addClass("disabled");
                }
            },
            success: function (posts) {
                $(".archive-blog__ajax__hidden").empty().append(posts);
                $("#archive-blog__ajax").attr("data-numberdisplayed", parseInt(numberdisplayedvalue) + 6);
                if (numberdisplayedvalue != 0) {
                    $('.archive .archive-blog .button-dinos').removeClass("disabled");
                }
            },
            error: function () {
                alert("error");
            }
        });
    }

    $('.archive .archive-blog .button-dinos').on('click', function (event) {
        event.preventDefault();
        if (!$(this).hasClass("disabled")) {
            var category = $('.archive-blog .archive-blog__head a.active span').attr('term-id');
            var numberdisplayed = $('#archive-blog__ajax').attr("data-numberdisplayed");

            AjaxPosts(category, numberdisplayed);
        }
    });

    if ($('.big-accordion').length) {
        $('.big-accordion .acc_content:not(.one-element)').css("display", "none");

        $(document).on('click', '.acc_toggle:not(.one-element)', function () {
            if ($(this).hasClass("active")) {
                $(".acc_toggle").removeClass("active");
                $(this).next().slideUp().removeClass("active");
                $(".single_acc").removeClass("active");
            } else {
                $(".acc_toggle").removeClass("active");
                $(".single_acc").removeClass("active");
                $(this).parent().addClass("active");
                $(this).addClass("active");
                $(this).next().slideToggle().addClass("active");
                //Hide the other panels
                $(".acc_content").not($(this).next()).slideUp().removeClass("active");
            }
        });
    }

    //Menu
    var parentSubMenu = $('.custom-menu .menu .menu-item-has-children');
    var subMenu = $('.custom-menu .menu .menu-item-has-children .sub-menu');
    var subMenuItem = $('.custom-menu .menu .menu-item-has-children .sub-menu > li');
    var subMenuFirstItem = $('.custom-menu .menu .menu-item-has-children .sub-menu > li:first-child')

    parentSubMenu.mouseover(function () {
        $('#container').addClass('bg-shade');
    });
    parentSubMenu.mouseout(function () {
        $('#container').removeClass('bg-shade');
    });

    subMenuFirstItem.addClass('hover');
    subMenu.each(function () {
        subMenuItem.mouseover(function () {
            if (!$(this).hasClass('hover')) {
                subMenuItem.removeClass('hover');
                $(this).addClass('hover');
            }
            $('#container').addClass('bg-shade');
        });
        subMenuItem.mouseout(function () {
            subMenuFirstItem.addClass('hover');
            $(this).removeClass('hover');
        });
        subMenu.mouseover(function () {
            $('#container').addClass('bg-shade');
        });
        subMenu.mouseout(function () {
            subMenuFirstItem.addClass('hover');
            $('#container').removeClass('bg-shade');
        });
    });

    /*global dataLayer*/

    // Global variable to hold the form data
    let gformGlobalData;

    function updateGformData() {
        let formData = {};

        $('.gform_wrapper form').each(function () {
            $(this).find(':input').each(function () {
                formData[$(this).attr('name')] = $(this).val();
            });
        });
        gformGlobalData = formData;
    }

    updateGformData();

    $(document).on('change', '.gform_wrapper form :input', function () {
        updateGformData();
    });

    /*eslint no-undef: "error"*/
    $(document).on('gform_confirmation_loaded', function (event, formId) {

        const formMapping = {
            '1': { 'email': 'input_1' },
            '2': { 'name': 'input_2', 'surname': 'input_3', 'email': 'input_4', 'tel': 'input_5' },
            '3': { 'name': 'input_1', 'email': 'input_2' },
            '4': { 'name': 'input_1', 'email': 'input_2' },
            '5': { 'name': 'input_1', 'email': 'input_2' },
            '6': { 'name': 'input_1', 'email': 'input_2' },
            '7': { 'name': 'input_1', 'email': 'input_2', 'tel': 'input_3' },
            '8': { 'name': 'input_1', 'email': 'input_2', 'tel': 'input_3' },
            '9': { 'name': 'input_1', 'email': 'input_2', 'tel': 'input_3' },
            '10': { 'name': 'input_1', 'email': 'input_2', 'tel': 'input_3' },
            '12': { 'name': 'input_1', 'email': 'input_2' },
            '14': { 'name': 'input_1', 'email': 'input_2' }
        };

        const formFields = formMapping[formId] || {};
        const getValue = field => field && gformGlobalData[field] ? gformGlobalData[field].trim() : '';

        let name = getValue(formFields.name);
        let surname = getValue(formFields.surname);
        let email = getValue(formFields.email);
        let tel = getValue(formFields.tel);

        let dataLayerName = name + (surname ? ' ' + surname : '');
        let dataLayerEmail = email;
        let dataLayerTel = tel;

        dataLayer.push({
            'event': 'formSubmittedOW',
            'formID': formId,
            'name': dataLayerName,
            'email': dataLayerEmail,
            'tel': dataLayerTel
        });
    });

});